import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=d354487e&"
import script from "./CollapsableCard.vue?vue&type=script&lang=js&"
export * from "./CollapsableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports